import * as types from "./mutations-types";

export default {
    [types.SET_LIST_ACCOUNTS](state, accounts) {
        state.accounts = accounts;
    }
};